import React from "react";
import { Wrapper } from "./components/Scoresheet";

function App() {
  return (
    <div className="App">
      <Wrapper />
    </div>
  );
}

export default App;
